import * as React from 'react';
import { Col, Row } from 'antd';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Button from '../../../../components/button/Button';
import FlightInfo from '../../../../components/flightInfo/FlightInfo';
import './PNRItemContainer.css';
import pnrToPnrItemModelAssembler from '../../../../services/detail/PnrToPnrItemModelAssembler';
import InfoModal from '../../../../components/searchBox/infoModal/InfoModal';
import ModalLoad from '../../../../components/modalLoad/ModalLoad';
import utils from '../../../../components/utils/utils';
import * as detailPnrService from '../../../../services/detail/DetailPnrService';
import { Currency } from '../../../../const/CurrencyType';

const I18n = require('i18n-react').default;

const propTypes = {
  detailPNR: PropTypes.any,
  data: PropTypes.any,
  compareDate: PropTypes.bool
};

class PNRItemContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRedirect: false,
      urlRedirect: ''
    };
  }

  showDetailPNR = () => {
    this.searchPNRDetail();
  };

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };

  searchPNRDetail() {
    sessionStorage.setItem('scrollSearchPnr', window.scrollY);
    this.setState({
      showLoading: true
    });
    detailPnrService.detailPnr(this.props.data.pnrId)
      .then(response => {
        if (response && response.error) throw response;
        this.setState({
          pnrDataDetail: pnrToPnrItemModelAssembler.assemblePnrItemModel(response.data),
          showLoading: false,
          isRedirect: true,
          urlRedirect: 'flightDetails'
        });

      })
      .catch(error => {
        this.setState({
          showLoading: false
        });
        utils.addScroll()
        this.showModal(I18n.translate('home.msg.error'));
      });
  }

  renderModalLoading() {
    return (
      <ModalLoad
        id="modalLoad"
        showModal={this.state.showLoading}
        ref={c => {
          this.modalLoad = c;
        }}
      />
    );
  }

  renderReturnFlight() {
    const returnFlight = this.props.data.cart.items[0].returnFlight;
    if (returnFlight) {
      return (
        <Row className="margin-eight-top-8">
          <Col>
            <FlightInfo
              name="returnFlight"
              className="FlightInfo__arrival"
              isDepartureFlight={false}
              flight={returnFlight}
              isPointsPlusMoney={this.isPointsPlusMoneyByFlight(returnFlight)}
              compareDate={this.props.compareDate}
            />
          </Col>
        </Row>
      );
    }
  }

  render() {
    return (
      <div className="PNRItemContainer padding-eight-top-56">
        {this.state.showLoading ? this.renderModalLoading() : ''}
        <Row>
          <Col
            span={12}
            className="PNRItemContainer__pnr text-xl text-dark-blue padding-eight-bottom-8">
            {i18n.translate('features.pnrItemContainer.tracker')}{' '}
            <b data-test="pnrNumber">{this.props.data.pnrNumber}</b>
          </Col>
          <Col span={12} className="PNRButtonContainer__pnr">
            <Row>
              <Col span={8} className="PNRItemContainer__showDetails">
                <Button
                  name="showDetails"
                  background="navy-blue"
                  className="text-xl"
                  disabled={false}
                  onClick={this.showDetailPNR}>
                  {i18n.translate('features.pnrItemContainer.showDetails')}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <FlightInfo
              name="departureFlight"
              className="FlightInfo__departure"
              isDepartureFlight={true}
              flight={this.props.data.cart.items[0].departureFlight}
              isPointsPlusMoney={this.isPointsPlusMoneyByFlight(this.props.data.cart.items[0].departureFlight)}
              compareDate={this.props.compareDate}
            />
          </Col>
        </Row>
        <InfoModal
          id="modalError"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalError = c;
          }}
        />
        {this.renderReturnFlight()}
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                azulNumber: this.props.azulNumber,
                pnrDataDetail: this.state.pnrDataDetail
              }
            }}
          />
        ) : null}
      </div>
    );
  }

  isPointsPlusMoneyByFlight(flight) {        
    const result = flight.total.filter((value) => value.currency === Currency.MONEY)[0];
    return result && result.value > 0
  }
}

PNRItemContainer.propTypes = propTypes;
export default PNRItemContainer;



// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/PNRItem/PNRItemContainer.jsx